import React, {useEffect, useState} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {useHistory} from 'react-router-dom';
import {sendEvarData} from '@ibibo/analytics';
import {
  NON_EDITABLE_STATUS,
  AGENCY_DETAILS_NEW_URL,
  DOCUMENT_UPLOAD_KYC_URL,
  LOGIN_WITH_MMT_PASSWORD_URL,
  CREATE_PASSWORD_PAGE_URL,
  TERMS_CONDITIONS_PAGE_URL,
  ACCOUNT_CREATED_PAGE_URL,
  ACCOUNT_MANUAL_PAGE_URL,
  VERIFY_OTP_NEW_URL,
} from '../../../constants';
import OtpBlock from '../../../stories/components/OnboardingNew/PopUp/OtpBlock/OtpBlock';
import * as actions from '../../../store/actions/index';
import {getGccMobileVerificationData} from '../../../store/actions/thunk';
import {
  statusSelector,
  emailSelector,
  errorSelector,
  tokenSelector,
  mobileWithCodeSelector,
  nextLoader,
  mobileCount,
  emailCount,
  headingSelector,
  existingUserSelector,
  nextScreenSelector,
  mobileSelector,
  userCountrySelector,
} from '../../../store/selectors';
import {
  setter,
  removeItem,
} from '../../../../../../common/client-side-storage/src/client-side-storage.web';
import {
  login,
  setAgentData,
  updateSid,
  submitOtp,
  setAgentDataNew,
} from '../../../store/actions/thunk';
import ForgetPassword from '../../../stories/components/OnboardingNew/PopUp/ForgetPassword/ForgetPassword';
import MobileVerification from '../../../stories/components/OnboardingNew/GccComponents/MobileVerification/MobileVerification';
import {
  redirectToSameWindowWithoutRefresh,
  getUrlWithCrid,
  getCrid,
} from '../../../../../myaccount/src/utils/redirectWithCrId';
import {useAnalyticService} from '@ibibo/analytics-provider';
const OtpVerify = () => {
  const history = useHistory();
  const {sendTrackingDataToSdk} = useAnalyticService();
  const [apiError, setApiError] = useState('');
  const [sendOTPResponse, setSendOTPResponse] = useState(null);
  const [apiDataObject, setApiDataObject] = useState({message: '', data: {account_exists: true}});
  const [updatePwdApiError, setUpdatePwdApiError] = useState('');
  const [forgotPasswordLoader, setForgotPasswordLoader] = useState(false);
  const [updatePwdSuccessMessage, setUpdatePwdSuccessMessage] = useState('');
  const [showMobileVerification, setShowMobileVericiation] = useState(false);
  const [responseRedirectUrl, setResponseRedirectUrl] = useState('');
  const [popupToShow, setPopupToShow] = useState('');
  const [mobileVerificationData, setMobileVerificationData] = useState(null);
  const [loginPageFlag, setLoginPageFlag] = useState(true);
  const [is2FARequired, setIs2FARequired] = useState(false);

  let userUrl = '';
  if (typeof window !== 'undefined') {
    userUrl = window.location.search;
  }
  let newUrl = userUrl.substring(1);
  let docRef = document.referrer;

  const token = useSelector(tokenSelector);
  const status = useSelector(statusSelector);
  const email = useSelector(emailSelector);
  const mobile = useSelector(mobileWithCodeSelector);
  const error = useSelector(errorSelector);
  const setLoader = useSelector(nextLoader);
  const mobile_count = useSelector(mobileCount);
  const email_count = useSelector(emailCount);
  const headingData = useSelector(headingSelector);
  const exitingNumber = useSelector(existingUserSelector);
  const nextScreen = useSelector(nextScreenSelector);
  const userMobile = useSelector(mobileSelector);
  const isLoading = useSelector(nextLoader);
  const userCountry = useSelector(userCountrySelector);

  const dispatch = useDispatch();

  useEffect(() => {
    fetchRequestForPopupType();
  }, [popupToShow]);

  const fetchRequestForPopupType = () => {
    if (popupToShow) {
      if (popupToShow === 'Mobile_Verification') {
        dispatch(
          getGccMobileVerificationData(
            gccMobileVerificationSuccessCallback,
            gccMobileVerificationErrorCallback,
          ),
        );
      } else {
        window.open(responseRedirectUrl, '_self');
      }
    }
  };

  const editField = () => {
    history.goBack();
  };
  const deviceWidth = window.screen.width;
  let blockType = false;
  if (deviceWidth > 1024) {
    blockType = true;
  }

  const resendOTP = type => {
    let fd = new FormData();
    fd.append('token', token);
    if (type === 'motp') {
      fd.append('resend', 'mobile');
      sendEvarData(
        {
          prop54: 'myPartner|signup|OTPVerification|resendOTP|mobile',
        },
        true,
      );
    }
    // if (type === 'eotp') {
    //     fd.append('resend', 'email');
    //     sendEvarData({
    //         prop54: "myPartner|signup|OTPVerification|resendOTP|email"
    //       }, true)
    // }
    dispatch(actions.resendOTP(fd, type));
  };

  useEffect(() => {
    setter('token', `${token}`);
  }, []);

  const successCallback = screen => {
    dispatch(actions.submitKYCModalInfo(''));
    // if (NON_EDITABLE_STATUS.indexOf(statusStr) !== -1) {
    //   history.push(`${DOCUMENT_UPLOAD_KYC_URL}`);
    // } else {
    //   history.push(`${AGENCY_DETAILS_NEW_URL}`);
    // }
    switch (screen) {
      case 'kyc_doc':
        history.push(`${DOCUMENT_UPLOAD_KYC_URL}?crId=${getCrid()}`);
        break;
      case 'create_password':
        history.push(`${CREATE_PASSWORD_PAGE_URL}?crId=${getCrid()}`);
        break;
      case 'mmt_password':
        history.push(`${LOGIN_WITH_MMT_PASSWORD_URL}?crId=${getCrid()}`);
        break;
      case 'tnc':
        history.push(`${TERMS_CONDITIONS_PAGE_URL}?crId=${getCrid()}`);
        break;
      case 'verification':
        history.push(`${ACCOUNT_CREATED_PAGE_URL}?crId=${getCrid()}`);
        break;
      case 'manual':
        history.push(`${ACCOUNT_MANUAL_PAGE_URL}?crId=${getCrid()}`);
        break;
      default:
        history.push(`${AGENCY_DETAILS_NEW_URL}?crId=${getCrid()}`);
        break;
    }
  };

  const verifyMobileOtpSuccess = data => {
    // if (NON_EDITABLE_STATUS.indexOf(status) !== -1) {
    //   successCallback(status);
    //   return;
    // }
    let fd = new FormData();
    fd.append('mobile_otp', data.mobile_otp);
    // fd.append('email_otp', data.email_otp);
    fd.append('token', token);
    fd.append('mobile', userMobile);
    dispatch(submitOtp(fd, successCallback));
  };

  const sendOTPCaller = data => {
    let fd = new FormData();
    if (deviceWidth < 1024) {
      fd.append('dt', 'false');
    } else {
      fd.append('dt', 'true');
    }
    fd.append('username', userCountry ? email : data.username);
    // clearUpdatePasswordMessages()
    setApiError('');
    fd.append('referrer', userUrl === '' ? docRef : newUrl);
    dispatch(login(fd, sendOTPSuccessCallback, errorCallback));
  };

  const successSetAgentData = () => {
    history.push(redirectToSameWindowWithoutRefresh(VERIFY_OTP_NEW_URL));
  };

  const errorSetAgentData = () => {};

  const sendOTPSuccessCallback = resp => {
    setSendOTPResponse(resp);
    if (resp.data.status && resp.data.token) {
      dispatch(setAgentDataNew(resp.data.token, successSetAgentData, errorSetAgentData));
    }
  };

  const errorCallback = error => {
    setApiError(error.message || 'Error! Please try after sometime.');
    setSendOTPResponse(error);
    // to handle the case where we want to update the pwd(MMT account exists or not)
    setApiDataObject(error);
  };

  const successLoginCallback = (resp, sendOTPFn) => {
    if (resp.data.status && resp.data.token) {
      dispatch(setAgentDataNew(resp.data.token, successSetAgentData, errorSetAgentData));
    }

    function successUpdateCallback(status) {
      if (resp.is2FARequired) {
        setIs2FARequired(resp.is2FARequired);
        //this case is required where we want to agent to land to OTP verification as well because of multi factor authentication support.
        sendOTPFn();

        sendEvarData(
          {
            prop54: 'myp_MFAShown',
          },
          true,
        );
        sendTrackingDataToSdk?.(
          {
            event_detail: {
              event_name: 'click',
              event_type: 'user_action',
              event_value: '2FAShown',
            },
          },
          'HOME',
        );
        return;
      }
      if (resp.mmt_auth) {
        setter('myPartnerAuth', {mmt_auth: resp.mmt_auth});
        setter('experiment', {experiment: resp.experiment});
      }
      if (resp.redirect_url) {
        //window.open(resp.redirect_url, '_self');
        setResponseRedirectUrl(resp.redirect_url);
      } else {
        // window.open('/hotels/', '_self');
        setResponseRedirectUrl('/hotels/');
      }
      if (resp?.popup_type) {
        setPopupToShow(resp.popup_type);
      } else {
        window.open(resp.redirect_url, '_self');
      }
    }

    dispatch(updateSid(resp, successUpdateCallback, false));
  };

  const submitDetails = (data, sendOTPFn) => {
    let fd = new FormData();
    if (deviceWidth < 1024) {
      fd.append('dt', 'false');
    } else {
      fd.append('dt', 'true');
    }
    fd.append('username', userCountry ? email : data.username);
    if (sendOTPResponse && sendOTPResponse.data && sendOTPResponse.data.token) {
      fd.append('token', sendOTPResponse.data.token);
    }
    if (data.password) {
      fd.append('password', data.password);
    }
    if (data.mobile_otp) {
      fd.append('mobile_otp', data.mobile_otp);
    }
    // fd.append('token', token);

    if (apiDataObject.data?.account_exists) {
      fd.append('token', token);
    }
    // clearUpdatePasswordMessages()
    // setUpdatePwdSuccessMessage('');
    // setUpdatePwdApiError('');
    fd.append('referrer', userUrl === '' ? docRef : newUrl);
    dispatch(login(fd, successLoginCallback, errorCallback, sendOTPFn));
  };

  //Forget password code
  const resendUpdatePwdOtp = () => {
    setUpdatePwdApiError('');
    dispatch(
      actions.getPassTokenOrResendToken(
        apiDataObject.data?.token,
        getTokenSuccessCallback,
        getTokenErrorCallback,
        'resend',
      ),
    );
  };

  // Forgot Pwd case(Get token and update pwd, account_exists: true)
  const getTokenSuccessCallback = forgotPwdApiTokenData => {
    setForgotPasswordLoader(false);
    setApiDataObject(forgotPwdApiTokenData);
  };
  const getTokenErrorCallback = error => {
    setForgotPasswordLoader(false);
    setApiError(error.message || 'Error! Please try after sometime.');
  };
  const getToken = username => {
    setForgotPasswordLoader(true);
    clearUpdatePasswordMessages();
    dispatch(
      actions.getPassTokenOrResendToken(
        username,
        getTokenSuccessCallback,
        getTokenErrorCallback,
        'forgotPwd',
      ),
    );
  };

  const clearUpdatePasswordMessages = () => {
    setUpdatePwdApiError('');
    setUpdatePwdSuccessMessage('');
  };

  const setPassword = data => {
    let fd = new FormData();
    fd.append('password', data.password);
    fd.append('confirm_password', data.confirm_pass);
    fd.append('token', apiDataObject.data?.token);
    fd.append('otp', data.mobile_otp);
    dispatch(actions.updatePass(fd, updatePassSuccessCallback, updatePassErrorCallback));
  };

  // Update Pwd Case (account_exists: false)
  const updatePassSuccessCallback = (succcessDataOrErrorData: any) => {
    setApiDataObject(succcessDataOrErrorData);
    // to show the updated message on login form for successfull pwd change after he comes back from update pwd page.
    setUpdatePwdSuccessMessage(
      succcessDataOrErrorData.message || 'Error! Please try after sometime.',
    );
    setApiError('');
  };
  const updatePassErrorCallback = data => {
    setUpdatePwdApiError(data.message);
  };

  const gccMobileVerificationSuccessCallback = data => {
    setMobileVerificationData(data);
    if (data.feature_enable) {
      if (data.is_verified) {
        window.open(responseRedirectUrl, '_self');
      } else {
        setLoginPageFlag(false);
      }
    } else {
      //window.open('https://www.makemytrip.com/flights/?action=smartbuy&open=browser', '_self');
      window.open(responseRedirectUrl, '_self');
    }
  };

  const gccMobileVerificationErrorCallback = data => {
    sendEvarData(
      {
        prop22: 'error_fetching_the_email_verification_data',
      },
      true,
    );
    window.open(responseRedirectUrl, '_self');
  };

  const {message} = apiDataObject;

  let getLoginOrUpdatePwdForm = (
    <>
      {loginPageFlag ? (
        <OtpBlock
          onOTPSubmit={verifyMobileOtpSuccess}
          editField={editField}
          resendOTP={resendOTP}
          email={email}
          mobile={mobile}
          apiError={error}
          loginApiError={apiError}
          setLoader={setLoader}
          status={status}
          mobile_count={mobile_count}
          email_count={email_count}
          headingData={headingData}
          eu={exitingNumber}
          sendOTP={sendOTPCaller}
          submitDetails={submitDetails}
          userMobile={userMobile}
          getToken={getToken}
          userCountry={userCountry}
          is2FARequired={is2FARequired}
        />
      ) : (
        <MobileVerification
          mobileNumber={mobileVerificationData?.mobile}
          responseRedirectUrl={responseRedirectUrl}
        />
      )}
    </>
  );
  if (
    apiDataObject?.data?.hasOwnProperty('account_exists') &&
    !apiDataObject?.data?.account_exists
  ) {
    getLoginOrUpdatePwdForm = (
      <ForgetPassword
        apiError={updatePwdApiError}
        resendOTP={resendUpdatePwdOtp}
        setPassword={data => setPassword(data)}
        isLoading={isLoading}
        loginApiMessage={message}
        // mobileUser={userMobile}
        //  setLoader={setLoader}
      />
    );
  }

  return getLoginOrUpdatePwdForm;
};

export default OtpVerify;
